import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-store-details-card-short',
  templateUrl: './store-details-card-short.component.html',
  styleUrls: ['./store-details-card-short.component.scss']
})
export class StoreDetailsCardShortComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
